import { ChevronLeft } from "lucide-react-native";
import { Pressable, ScrollView, Text, View } from "react-native";
import { useTranslations } from "@src/packages/i18n";
import {
  pressLabel,
  usePressCapture,
} from "@src/packages/analytics/usePressCapture";
import { EMBER } from "../../../../onboarding/theme";
import GlassScreenLayout from "@louise/moon-ui/primitives/GlassScreenLayout";
import { GLASS_CARD_STYLE } from "@louise/moon-ui/theme/tokens";

type Props = {
  title: string;
  onBack: () => void;
  children: React.ReactNode;
  overlay?: React.ReactNode;
};

export default function YouDetailScreenLayout({
  title,
  onBack,
  children,
  overlay,
}: Props) {
  const t = useTranslations();
  const capturePress = usePressCapture("YouDetailScreenLayout");

  return (
    <GlassScreenLayout overlay={overlay}>
      <ScrollView
        contentContainerStyle={{
          padding: 16,
          paddingBottom: 100,
          maxWidth: 520,
          width: "100%",
          alignSelf: "center",
        }}
        showsVerticalScrollIndicator={false}
      >
        <Pressable
          onPress={() => {
            capturePress(pressLabel(t("you.shared.back")), "you.shared.back");
            onBack();
          }}
          style={{
            flexDirection: "row",
            alignItems: "center",
            gap: 4,
            marginBottom: 16,
          }}
        >
          <ChevronLeft size={18} color={EMBER.colors.warm} />
          <Text
            className="font-dm-sans"
            style={{
              fontSize: 14,
              fontWeight: "500",
              color: EMBER.colors.warm,
            }}
          >
            {t("you.shared.back")}
          </Text>
        </Pressable>

        <View
          style={{
            ...GLASS_CARD_STYLE,
            paddingHorizontal: 20,
            paddingVertical: 24,
          }}
        >
          <Text
            className="font-dm-sans"
            style={{
              fontSize: 20,
              fontWeight: "600",
              color: EMBER.colors.text,
              marginBottom: 24,
            }}
          >
            {title}
          </Text>

          {children}
        </View>
      </ScrollView>
    </GlassScreenLayout>
  );
}
